<h2>Country Data Mapping</h2>

<div class="px-2 py-3 contents h-full max-h-80" *ngIf="isLoadCountryMasterGridDataSource">
    <div class="flex pb-4 justify-start">
        <dx-check-box [value]="false" text="Include deactivated Country Mapping items" class="pr-2" (onValueChanged)="extraFilteringOptionsChange('Active', $event)"></dx-check-box>
    </div>
    <div class="mapping-grid-container shadow-lg">
        <dx-data-grid
            #countryMappingDataGrid
            id="countryMappingDataGrid"
            [allowColumnResizing]="true"
            [columnResizingMode]="'widget'"
            [allowColumnReordering]="true"
            [dataSource]="countryMappingDataSource"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [remoteOperations]="true"
            [hoverStateEnabled]="true"
            [(selectedRowKeys)]="countryMappingSelectedRowMap"
            (onSelectionChanged)="selectionMappingDataChangedHandler()"
            (onContentReady)="onReady($event)"
            (onContextMenuPreparing)="countryMappingDataGridContextMenu($event)"
            keyExpr="CountryMappingId"
        >
            <dxo-state-storing
                    [enabled]="true"
                    type="custom"
                    [customLoad]="loadMasterState"
                    [customSave]="saveMasterState">
            </dxo-state-storing>
            <dxo-load-panel
                    [enabled]="false"
                    shadingColor="rgba(0,0,0,0.4)"
                    [showIndicator]="true"
                    [showPane]="true"
                    [shading]="true">
            </dxo-load-panel>
            <dxo-filter-panel [visible]="true"></dxo-filter-panel>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-pager
                    [visible]="true"
                    [allowedPageSizes]="[5, 10, 25, 50, 100]"
                    displayMode="compact"
                    [showPageSizeSelector]="true"
                    [showNavigationButtons]="false"
            >
            </dxo-pager>
            <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
            <dxo-selection mode="single"></dxo-selection>
            <dxo-column-chooser [enabled]="true" mode="dragAndDrop"></dxo-column-chooser>
            <dxi-column dataField="CountryMappingId" [allowHeaderFiltering]="false" [width]="140" caption="Country Mapping" [customizeText]="customizeCountryMasterId"></dxi-column>
            <dxi-column caption="Action" cellTemplate="action" alignment="center" [allowHeaderFiltering]="false"></dxi-column>
            <dxi-column dataField="SourceCountry" caption="Source Country">
                <dxo-header-filter [dataSource]="sourceCountryHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column dataField="MappingModeName" caption="Mapping Mode" [allowHeaderFiltering]="false" [allowFiltering]="false">
            </dxi-column>
            <dxi-column dataField="MappingModeId" caption="Mapping Mode Id" [alignment]="'left'">
                <dxo-header-filter [dataSource]="mappingModeNameHeaderDataSource"></dxo-header-filter>
            </dxi-column>
            <dxi-column caption="Mapped to">
                <dxi-column dataField="CountryShortName" caption="Country Name">
                    <dxo-header-filter [dataSource]="countryShortNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CountryIsActive" caption="Country Is Active" [allowHeaderFiltering]="false">
                </dxi-column>
                <dxi-column dataField="ReportList" caption="Report List">
                    <dxo-header-filter [dataSource]="reportListHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Data provider">
                <dxi-column dataField="DataProviderCode" caption="Code">
                    <dxo-header-filter [dataSource]="dataProviderCodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="DataProviderPrimaryOrDefaultCountryGeographicalEntityShortName" caption="Default Country">
                    <dxo-header-filter [dataSource]="dataProviderShortNameHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="DataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2Code" caption="Country Code">
                    <dxo-header-filter [dataSource]="dataProviderPrimaryOrDefaultCountryGeographicalEntityCountryAlpha2CodeHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="IsDataProviderPrimaryOrDefaultCountryInconsistentMappingMessage" caption="Inconsistent Mapping">
                    <dxo-header-filter [dataSource]="isDataProviderPrimaryOrDefaultCountryInconsistentMappingMessageHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <dxi-column caption="Data auditing">
                <dxi-column dataField="CreatedByUserFullNameSortableOrPrincipalName" caption="Created by" [visible]="false">
                    <dxo-header-filter [dataSource]="createdByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="CreatedOn" caption="Create on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="createdOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedByUserFullNameSortableOrPrincipalName" caption="Modified by" >
                    <dxo-header-filter [dataSource]="modifiedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ModifiedOn" caption="Modified on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="modifiedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedByUserFullNameSortableOrPrincipalName" caption="Reviewed by" [visible]="false">
                    <dxo-header-filter [dataSource]="reviewedByHeaderDataSource"></dxo-header-filter>
                </dxi-column>
                <dxi-column dataField="ReviewedOn" caption="Reviewed on" dataType="date" format="M/d/yyyy, HH:mm" dataType="datetime" [visible]="false" cssClass="hide-filter-icon">
                    <dxo-header-filter [dataSource]="reviewedOnHeaderDataSource"></dxo-header-filter>
                </dxi-column>
            </dxi-column>
            <div *dxTemplate="let action of 'action'">
                <dx-button class="mr-1" icon="fas fa-ban fa-1x" hint="Omit" [disabled]="action?.data?.MappingModeId == 3" (onClick)="omit(action?.data?.CountryMappingId)"></dx-button>
                <dx-button class="mr-1" icon="far fa-bookmark fa-1x" hint="Save" [disabled]="action?.data?.MappingModeId == 2" (onClick)="save(action?.data?.CountryMappingId)"></dx-button>
                <dx-button class="mr-1" icon="fas fa-map-marker-alt fa-1x" hint="Map" [disabled]="action?.data?.MappingModeId == 1" (onClick)="map(action?.data?.CountryMappingId, action?.data?.DataProviderPrimaryOrDefaultCountryGeographicalEntityId)"></dx-button>
                <dx-button
                        id="btnAccept"
                        *ngIf="action?.data?.ModifiedByUserId <= 0 && action?.data?.MappingModeId == 0"
                        class="mr-1"
                        icon="fa fa-check fa-1x"
                        hint="Accept"
                        (onClick)="accept(action?.data?.CountryMappingId)"
                ></dx-button>
                <dx-button
                        id="btnReview"
                        class="mr-1"
                        *ngIf="action?.data?.ModifiedByUserId > 0 && action?.data?.ModifiedByUserId != currentUser?.UserId && action?.data?.ReviewedByUserId == -1"
                        icon="fas fa-check-double fa-1x"
                        hint="Review"
                        (onClick)="review(action?.data?.CountryMappingId)"
                ></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Deactivate" (onClick)="deactivate(action?.data?.CountryMappingId)"></dx-button>
                <dx-button *ngIf="currentUser?.UserRoleId > 1 && !action?.data?.Active" icon="fas fa-trash-alt fa-1x" hint="Reactivate" (onClick)="reactivate(action?.data?.CountryMappingId)"></dx-button>
            </div>
            <dxo-paging [pageSize]="5"></dxo-paging>
        </dx-data-grid>
    </div>
</div>
